import theme from "@/styles/theme";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import { TransitionGroup } from "react-transition-group";
import EventFilterContainer from "./EventFilterContainer";

export default function EventFilter({ ref, filter, onChange, ...props }) {
  const [filterOpen, setFilterOpen] = useState(false);

  const handleFilterChanged = (name, value) => {
    if (onChange && typeof onChange === "function") {
      onChange(name, value);
    }
  };

  useEffect(() => {
    setFilterOpen(window.innerWidth >= 900);
  }, []);

  return (
    <Grid container spacing={{ xs: 1, md: 3 }} sx={eventFilterStyles}>
      <Grid item xs={12}>
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          startIcon={<FilterAltIcon />}
          onClick={() => setFilterOpen(!filterOpen)}
          sx={{ display: { md: "none" }, mb: 2 }}
        >
          {filterOpen ? "Filter schließen" : "Filter anzeigen"}
        </Button>
        <TransitionGroup>
          <Box
            style={{ display: filterOpen ? "inherit" : "none" }}
            ref={ref}
            {...props}
          >
            <EventFilterContainer
              filter={filter}
              onChange={handleFilterChanged}
            />
          </Box>
        </TransitionGroup>
      </Grid>
    </Grid>
  );
}

const eventFilterStyles = {
  [theme.breakpoints.up("md")]: {
    position: "sticky",
    top: 140,
  },
};
